import request from "@/router/axios";

// 获取未读消息数
export const getMessage = (messageTypeParent,userId) => {
  return request({
    url: `/api/blade-loanMessage/loanMessage/getMessage`,
    method: "get",
    params: {
      messageTypeParent,userId
    },
  });
}
// 获取所有未读消息数量
export const getAllMessageNum = (userId) => {
  return request({
    url: `/api/blade-loanMessage/loanMessage/getAllMessageNum`,
    method: "get",
    nprogress:'nprogress',
    params: {
      userId
    },
  });
}
